import React, { useContext, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import Scorebar from "../pages/scanDetails/Scorebar";
import { GlobalContext } from "../Context/GlobalContext";
import Chart from "react-apexcharts";
import { getCategoryStyle } from "../utils";

const HealthDetailDrawer = ({
  show,
  onClose,
  showIconAndImage,
  metricData,
  isPublic = false,
}) => {
  const {
    translatedLabels,
    listBioMarker,
    bioMarker,
    wellnessLabelNormal,
    wellnessLabel,
    is4Life,
  } = useContext(GlobalContext);

  useEffect(() => {
    if (isPublic) return;
    listBioMarker();
  }, [listBioMarker, isPublic]);

  const screenLabels = translatedLabels?.common;

  // const [showDetailedView, setShowDetailedView] = useState(false);

  // useEffect(() => {
  //   if (show) {
  //     setShowDetailedView(false);
  //   }
  // }, [show]);

  if (!metricData) return null;

  const {
    key,
    value,
    unit,
    status,
    icon,
    normal,
    cronologicalAge,
    source,
    avgValue,
    shadowColor,
  } = metricData;

  // const findLabelValue = (bioMarker, key) => {
  //   for (const category in bioMarker) {
  //     if (bioMarker[category][key]) {
  //       return bioMarker[category][key].label_value;
  //     }
  //   }
  //   return null;
  // };

  const findLabelValue = (bioMarker, key) => {
    for (const category in bioMarker) {
      if (category.toLowerCase() === "wellness") {
        if (is4Life) {
          if (bioMarker[category]["wellness_biomarker"]) {
            return bioMarker[category]["wellness_biomarker"].label_value;
          }
        } else {
          if (bioMarker[category]["wellness"]) {
            return bioMarker[category]["wellness"].label_value;
          }
        }
      }

      if (bioMarker[category][key]) {
        return bioMarker[category][key].label_value;
      }
    }
    return null;
  };

  const isRiskCategory = (bioMarker, key) => {
    return bioMarker?.Risks && bioMarker.Risks[key];
  };

  const hasKeyInBiomarker = (bioMarker, key) => {
    for (const category in bioMarker) {
      if (bioMarker[category][key]) return true;
    }
    return false;
  };

  const getCategoryName = (bioMarker, key) => {
    for (const category in bioMarker) {
      if (bioMarker[category][key]) {
        return category;
      }
    }
    return null;
  };

  const getCategoryBiomarkerKey = (category) => {
    if (!category) return null;

    const normalized = category.toLowerCase();

    if (normalized === "stress & recovery") {
      return "stress_recovery_biomarker";
    }

    return normalized.replace(/\s+/g, "_") + "_biomarker";
  };

  const vitalsKey = metricData.key + "_vitals";

  const isRisk = isRiskCategory(bioMarker, metricData.key);

  const metricKey =
    is4Life &&
      (source === "biomarker_dashboard" || source === "show_all_result") &&
      hasKeyInBiomarker(bioMarker, vitalsKey)
      ? vitalsKey
      : metricData.key;

  const categoryName = getCategoryName(bioMarker, metricData.key);
  const categoryBiomarkerKey = getCategoryBiomarkerKey(categoryName);
  const detailedContentRaw =
    source === "biomarker_dashboard" ||
      (source === "show_all_result" && !isRisk)
      ? findLabelValue(bioMarker, categoryBiomarkerKey)
      : findLabelValue(bioMarker, metricData.key);

  const detailedContent =
    detailedContentRaw && detailedContentRaw.trim() ? detailedContentRaw : null;

  const hasVitalsData = hasKeyInBiomarker(bioMarker, vitalsKey);

  return (
    <Offcanvas
      show={show}
      onHide={onClose}
      placement="bottom"
      className="p-0 text-black shadow-lg"
      style={{
        height: "80vh",
        backgroundColor: "#fff",
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
      }}
    >
      <Offcanvas.Body
        className="px-3 p-0 scrollable-content position-relative"
        style={{ overflow: "unset" }}
      >
        <div className="wellness-icon d-flex justify-content-center my-3">
          {icon ? (
            <img src={icon} alt={status} />
          ) : (
            <i
              className="fa-solid fa-2x fa-circle-info"
              style={{ color: "#607D8B" }}
            ></i>
          )}
        </div>

        <div className="canvas-content-part">
          {source === "biomarker_dashboard" &&
            (() => {
              const {
                icon: categoryIcon,
                color,
                shadow,
              } = getCategoryStyle(key);
              const isHeartHealth = key === "heart_age";

              return (
                <>
                  <div className="d-flex flex-column align-items-center">
                    <div
                      className={`card mt-4 card-width ${shadowColor ? `${shadow}` : "shadow-primary"} d-flex flex-row justify-content-between px-2 py-2 mb-3`}
                    >
                      <div className={`icon-wrapper ${color}`}>
                        <img
                          src={categoryIcon}
                          alt={key}
                          style={{ width: "24px", height: "24px" }}
                        />
                      </div>

                      <div className="flex-grow-1 px-2">
                        <h6 className="mb-0 fw-semibold welless-card-title">
                          {metricData.comment ||
                            screenLabels?.[key]?.label_value ||
                            key
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (c) => c.toUpperCase())}
                        </h6>

                        <div className="d-flex justify-content-between bp-details mt-1">
                          <div>
                            <p className="mb-0 font-bold fs-14px">
                              {isHeartHealth
                                ? screenLabels?.cronological_age?.label_value ||
                                "Chronological Age"
                                : screenLabels?.reading?.label_value ||
                                "Reading"}
                            </p>
                            <p className="mb-0 fs-14px fw-semibold">
                              {isHeartHealth
                                ? avgValue || "-"
                                : `${value ?? "-"} ${unit || ""}`}
                            </p>
                          </div>

                          <div>
                            <p className="mb-0 fs-14px text-end">
                              {isHeartHealth
                                ? screenLabels?.biological_age?.label_value ||
                                "Biological Age"
                                : wellnessLabel || "-"}
                            </p>
                            <p className="mb-0 fs-14px fw-semibold text-end">
                              {isHeartHealth
                                ? (value ?? "-")
                                : (avgValue ?? "-")}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })()}
          <>
            <div className="canvas-header">
              {key === "rri_data" ? (
                <div className="mt-2">
                  <Chart
                    type="line"
                    height={180}
                    options={{
                      chart: {
                        id: "rri-heart-rate-chart",
                        toolbar: { show: false },
                        zoom: { enabled: false },
                      },
                      stroke: { curve: "smooth", width: 2 },
                      markers: { size: 0 },
                      xaxis: {
                        title: {
                          text: screenLabels?.time_s?.label_value || "Time (s)",
                        },
                        labels: {
                          formatter: (val) => Number(val).toFixed(1),
                        },
                      },
                      yaxis: {
                        title: {
                          text:
                            screenLabels?.heart_rate_bpm?.label_value ||
                            "Heart Rate (BPM)",
                        },
                        min: 40,
                        max: 140,
                      },
                      tooltip: {
                        x: { formatter: (val) => `${val.toFixed(2)}s` },
                        y: { formatter: (val) => `${val.toFixed(2)} BPM` },
                      },
                    }}
                    series={[
                      {
                        name:
                          screenLabels?.heart_rate?.label_value || "Heart Rate",
                        data: Array.isArray(value)
                          ? value
                            .map((entry) => {
                              if (
                                entry &&
                                typeof entry === "object" &&
                                "timestamp" in entry &&
                                "interval" in entry
                              ) {
                                const bpm =
                                  Math.round((60000 / entry.interval) * 100) /
                                  100;
                                return [Number(entry.timestamp), bpm];
                              }
                              return null;
                            })
                            .filter(Boolean)
                          : [],
                      },
                    ]}
                  />
                </div>
              ) : (
                <div className="text-center py-3">
                  {key === "stress_level" ? (
                    <>
                      <h5 className="mb-0 text-center w-100">
                        {screenLabels?.current_read?.label_value ||
                          "Your Current"}{" "}
                        {screenLabels?.[key]?.label_value || "Stress Level"} —{" "}
                        {value === "1 score"
                          ? screenLabels?.low?.label_value || "Low nnn"
                          : value === "2 score"
                            ? screenLabels?.normal?.label_value || "Median"
                            : value === "3 score"
                              ? screenLabels?.high?.label_value || "High"
                              : "Unknown"}
                      </h5>

                      {!showIconAndImage && (
                        <div className="mt-3">
                          <Scorebar score={value * 33} />
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <h5 className="text-primary mb-0 text-center w-100">
                        {screenLabels?.current_read?.label_value ||
                          "Your Current"}{" "}
                        {screenLabels?.[key]?.label_value ||
                          screenLabels?.[key + "_comment"]?.label_value ||
                          key
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase())}{" "}
                        — {value} {unit}
                      </h5>

                      {!showIconAndImage && (
                        <div className="mt-3">
                          <Scorebar score={Math.round((value / 10) * 10)} />
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
            {normal && (
              <div className="text-black fs-15px mt-3">
                {key === "heart_age" && !is4Life ? (
                  <div>
                    <p>
                      <span className="fw-semibold">
                        {screenLabels?.current_cronologicalAge?.label_value ||
                          "Your Current Chronological Age"}
                        :{" "}
                      </span>{" "}
                      {cronologicalAge} {unit}
                    </p>
                    <p>
                      <span className="fw-semibold">
                        {screenLabels?.current_biologicalAge?.label_value ||
                          "Your Current Biological Age"}
                        :{" "}
                      </span>{" "}
                      {value} {unit}
                    </p>
                  </div>
                ) : (
                  <>
                    {(() => {
                      const looksLikeList =
                        normal.includes("\n") ||
                        normal.includes("  ") ||
                        normal.includes("Underweight") ||
                        normal.includes("Overweight") ||
                        normal.includes("Obese") ||
                        normal.includes("Normal Weight");

                      if (looksLikeList) {
                        const items = normal
                          .split(/\r?\n| {2,}/)
                          .map((item) => item.trim())
                          .filter(Boolean);
                        return is4Life ? null : (
                          <div>
                            <span className="fw-semibold">
                              {wellnessLabelNormal}:
                            </span>
                            <ul className="mt-2 mb-0 ps-3">
                              {items.map((line, idx) => (
                                <li key={idx}>{line}</li>
                              ))}
                            </ul>
                          </div>
                        );
                      }

                      return is4Life ? null : (
                        <>
                          <span className="fw-semibold">
                            {wellnessLabelNormal}:
                          </span>{" "}
                          {normal} {unit}
                        </>
                      );
                    })()}
                  </>
                )}
              </div>
            )}{" "}
            {(!is4Life ||
              hasVitalsData ||
              key.toLowerCase() === "wellness") && (
                <div
                  id="biomarker-description-summary"
                  className="text-black mt-2"
                  dangerouslySetInnerHTML={{
                    __html: findLabelValue(bioMarker, metricKey)
                      ? `<b style="font-size:18px; margin-bottom:0; font-weight: 500">${findLabelValue(bioMarker, metricKey)}</b>`
                      : "<p>Stay tuned! More insights about this metric are coming soon.</p>",
                  }}
                />
              )}
            {/* {source === "biomarker_dashboard" && detailedContent && (
              <div className="d-flex justify-content-end">
                <div
                  className="text-primary fw-bold cursor-pointer "
                  onClick={() => setShowDetailedView((prev) => !prev)}
                >
                  {showDetailedView
                    ? screenLabels?.view_less?.label_value || "View Less"
                    : screenLabels?.view_more?.label_value || "View More"}
                </div>
              </div>
            )} */}
            {!isRisk &&
              (source === "show_all_result" ||
                source === "biomarker_dashboard") &&
              detailedContent && (
                <p
                  id="biomarker-description-detailed"
                  className="text-black small mt-2"
                  dangerouslySetInnerHTML={{
                    __html: detailedContent,
                  }}
                />
              )}
            {/* {!isRisk &&
              (source === "show_all_result" || showDetailedView) &&
              detailedContent && (
                <p
                  id="biomarker-description-detailed"
                  className="text-black small mt-2"
                  dangerouslySetInnerHTML={{
                    __html: detailedContent,
                  }}
                />
              )} */}
          </>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default HealthDetailDrawer;
